import React, { useEffect } from 'react';

interface ScreenTapControlsProps {
  moveLeft: () => void;
  moveRight: () => void;
  rotate: () => void;
  gameArea: React.RefObject<HTMLDivElement | null>;
}

const ScreenTapControls: React.FC<ScreenTapControlsProps> = ({
  moveLeft,
  moveRight,
  rotate,
  gameArea
}) => {
  const handleTap = (event: TouchEvent) => {
    if (!gameArea.current) return;
    
    const rect = gameArea.current.getBoundingClientRect();
    const touchX = event.touches[0].clientX;
    const touchXRelative = touchX - rect.left;
    
    // Determine which third of the screen was tapped
    const leftThird = rect.width / 3;
    const rightThird = rect.width * 2 / 3;
    
    if (touchXRelative < leftThird) {
      moveLeft();
    } else if (touchXRelative > rightThird) {
      moveRight();
    } else {
      rotate();
    }
  };
  
  useEffect(() => {
    const element = gameArea.current;
    if (!element) return;
    
    element.addEventListener('touchstart', handleTap);
    
    return () => {
      element.removeEventListener('touchstart', handleTap);
    };
  }, [gameArea, moveLeft, moveRight, rotate]);
  
  return null; // This is an invisible control layer
};

export default ScreenTapControls;